import { Package } from 'lucide-react';

export default function Logo({ className = '', size = 'md', useImage = false }) {
  const sizes = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  const iconSizes = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-7 h-7',
    xl: 'w-9 h-9'
  };

  return (
    <div className={`${sizes[size]} ${useImage ? '' : 'bg-gradient-to-br from-blue-500 to-purple-600'} rounded-lg flex items-center justify-center ${className}`}>
      {useImage ? (
        <img 
          src="/logo.ico" 
          alt="P-TechAI Logo" 
          className={`${sizes[size]} object-contain rounded-lg`}
        />
      ) : (
        <Package className={`${iconSizes[size]} text-white`} />
      )}
    </div>
  );
}
